/**
 * Video controls
 */
if (document.getElementById("hero-columns-video") != null) {
  var video = document.getElementById("hero-columns-video");
  var playButton = document.getElementById("hero-columns-video-play-pause");

  var buttonMute = document.getElementById('hero-columns-video-audio-control');

  buttonMute.onclick = function (){
    if (!video.muted) {
      buttonMute.classList.replace('hero-columns__controller--audio-on', 'hero-columns__controller--audio-off');
      video.muted = true; // you need to assign this value to true
    } else {
      buttonMute.classList.replace('hero-columns__controller--audio-off', 'hero-columns__controller--audio-on');
      video.muted = false;
    }
  };

  var video_click = function() {
    if (video.paused === true) {
      video.play();
      video.focus();
      playButton.classList.replace('hero-columns__controller--play', 'hero-columns__controller--pause');

    } else {
      video.pause();
      playButton.classList.replace('hero-columns__controller--pause', 'hero-columns__controller--play');
    }
  };

  video.addEventListener("click", video_click);
  playButton.addEventListener("click", video_click);
}
